import SvgChevronLeft from "@clayton-homes/ui-icons/24/chevron-left";
import { ButtonLink } from "../../../components/client.button";
import { AnalyticEventNames } from "../../../utilities/env";
import { analytics } from "../../../utilities/segment";

interface ModelFinderNavBarProps {
	nextLink: string;
	nextDisabled: boolean;
	nextOnClick?: () => void;
	analyticsSelections: { size: string; beds?: string; features?: string[] };
	backLink?: string;
}
export function ModelFinderNavBar({
	nextLink,
	nextDisabled,
	nextOnClick,
	analyticsSelections,
	backLink,
}: ModelFinderNavBarProps) {
	return (
		<div className="mt-auto bg-white text-center">
			<div
				className={`${backLink ? "justify-between" : "justify-end"} wrapper-lg flex gap-4 py-4`}
			>
				{backLink ? (
					<ButtonLink href={backLink} className="w-44">
						<SvgChevronLeft className="inline h-4 w-4" /> BACK
					</ButtonLink>
				) : null}
				<ButtonLink
					disabled={nextDisabled}
					href={nextLink}
					className="w-44"
					onClick={() => {
						nextOnClick?.();
						analytics?.track(AnalyticEventNames.modelFinderUpdated, {
							selections: analyticsSelections,
						});
					}}
				>
					NEXT
				</ButtonLink>
			</div>
		</div>
	);
}
